
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M46.531 41.3H9.716a5.349 5.349 0 01-5.348-5.339V12.338A5.346 5.346 0 019.709 7h36.814a5.365 5.365 0 015.357 5.338v23.623a5.349 5.349 0 01-5.349 5.339zM9.709 12.338v23.623h36.814V12.338zM52.561 49.631H3.67a2.669 2.669 0 110-5.338h48.891a2.669 2.669 0 110 5.338z"}})])])
          )
        }
      }
    